<template>
  <div>
    <v-form>
      <p class="mb-3">
        What would the product be for an aldol condensation between diethylketone and 2 equivalents
        of
        <stemble-latex content="$p\text{-tolualdehyde?}$" />
      </p>

      <v-radio-group v-model="inputs.studentAnswer" :disabled="!allowEditing" class="mb-0 pl-6">
        <v-radio
          v-for="option in optionsShuffled"
          :key="'pt-1-' + option.value"
          class="my-3"
          :value="option.value"
        >
          <template #label>
            <img :src="option.img" alt="" :style="option.width" />
          </template>
        </v-radio>
      </v-radio-group>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import {seededShuffle} from '@/courses/utils/seededShuffle';
import {prefixPublicAsset} from '@/common/plugins/public-asset-plugin';

export default {
  name: 'ChemUCI_51LPPL7_Q8',
  components: {StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        studentAnswer: null,
      },
      options: [
        {
          img: prefixPublicAsset('/img/assignments/UCI_Prelab7_Q8_optionA.png'),
          value: 'a',
          width: 'max-width: 339px',
        },
        {
          img: prefixPublicAsset('/img/assignments/UCI_Prelab7_Q8_optionB.png'),
          value: 'b',
          width: 'max-width: 293px',
        },
        {
          img: prefixPublicAsset('/img/assignments/UCI_Prelab7_Q8_optionC.png'),
          value: 'c',
          width: 'max-width: 243px',
        },
        {
          img: prefixPublicAsset('/img/assignments/UCI_Prelab7_Q8_optionD.png'),
          value: 'd',
          width: 'max-width: 293px',
        },
      ],
    };
  },
  computed: {
    seed() {
      return this.$inertia.getSeed();
    },
    optionsShuffled() {
      return seededShuffle(this.options, this.seed);
    },
  },
};
</script>
